import cx from 'classnames'
import React from 'react'

const PageWrapperView: React.FC<
  React.PropsWithChildren<{
    iosStatusbarColor?: string
    topBarComponent?: false | React.ReactNode
    bgcolor?: string
    bottomBarComponent?: false | React.ReactNode
    className?: string
  }>
> = ({
  children,
  topBarComponent: TopBarComponent = false,
  bottomBarComponent: BottomBarComponent = false,
  className,
}) => {
  return (
    <div
      className={cx(
        'py-0 px-4 flex flex-col relative supports-[height:100cqh]:h-[100cqh] supports-[height:100svh]:h-[100svh]',
        className
      )}>
      {TopBarComponent}
      {children}
      {BottomBarComponent}
    </div>
  )
}

export default PageWrapperView
